export const cloudIcon = require("../assets/cloud_upload.png");
